import { render, staticRenderFns } from "./ConfigureShift.vue?vue&type=template&id=81ac7c78&scoped=true"
import script from "./ConfigureShift.vue?vue&type=script&lang=js"
export * from "./ConfigureShift.vue?vue&type=script&lang=js"
import style0 from "./ConfigureShift.vue?vue&type=style&index=0&id=81ac7c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ac7c78",
  null
  
)

export default component.exports